import { render, staticRenderFns } from "./TableInspectMerge.vue?vue&type=template&id=2cdf8cbf&scoped=true"
import script from "./TableInspectMerge.vue?vue&type=script&lang=js"
export * from "./TableInspectMerge.vue?vue&type=script&lang=js"
import style0 from "./TableInspectMerge.vue?vue&type=style&index=0&id=2cdf8cbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdf8cbf",
  null
  
)

export default component.exports